import {useSelector} from "react-redux";
import Table from "@/components/common/Table";
import {constructTableMetaFromPaging2} from "@/utils/paging";
import {RootState} from "@/store";
import {currencyFormat} from "@/utils";
import {ReactComponent as RiGroupFill} from "@/assets/icons/ri-group-fill.svg";
import {incomeBookingPriceStyle, incomeBookingStyle, incomeBookingType} from "@/pages/Report/constant";

interface IncomeStatementTableProps {
  handlePageChange: (page: number) => void
}

const HEADERS: TableHeader[] = [
  {
    label: 'BOOKING NO.',
    key: 'custom_id',
  },
  {
    label: 'CREATED',
    key: 'created_at',
  },
  {
    label: 'CUSTOMER',
    key: 'customer',
  },
  {
    label: 'TYPE',
    key: 'type'
  },
  {
    label: 'PAYMENT',
    key: 'paymentObject'
  },
  {
    label: 'TOTAL',
    key: 'priceObject'
  }
];
const SORT: TableSort = {
  type: 'SERVER',
  handler: () => {
  }
};

const renderId = (v) => <div className="text-jsm flex justify-start items-center text-black-primary text-center font-bold">{v}</div>
const renderDate = (timestamp: number) => {
	const createdDate = new Date(timestamp);
  return (
    <div className="text-jsm">
      {`${createdDate.toLocaleDateString()}, ${createdDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`}
    </div>
  )
}
const renderCustomer = customer => (
  <div className="flex flex-col gap-1">
    <div className="text-jsm font-bold text-black-primary">{customer.name}</div>
    <div className="flex text-blue-secondary gap-1 items-center">
      <div className="h-3 w-3 object-contain items-center justify-center">
        <RiGroupFill/>
      </div>
      {/* <div className="text-jxs font-medium">{customer.club_name}</div> */}
    </div>
  </div>
)
const renderPrice = (v: IncomeBookingPrice) => {
  const style = incomeBookingPriceStyle[v.type]
    ? incomeBookingPriceStyle[v.type]
    : incomeBookingPriceStyle[incomeBookingType.INCOME]
  const text = v.type || incomeBookingType.INCOME
  const textToDisplay = text === incomeBookingType.INCOME
    ? currencyFormat(v.total)
    : `- ${currencyFormat(v.total)}`
  return (
    <div className={`text-jsm ${style}`}>
      {textToDisplay}
    </div>
  )
}
const renderType = (status: string) => {
  const style = incomeBookingStyle[status]
    ? incomeBookingStyle[status]
    : incomeBookingStyle[incomeBookingType.INCOME]
  const text = status || incomeBookingType.INCOME
  const statusDisplay = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  
  return (
    <div className={`py-1 px-4 text-jsm flex-center rounded w-fit ${style}`}>
      {statusDisplay}
    </div>
  )
}

const renderPaymentMethod = (payment: IncomeBookingPayment) => {
  const createdDate = new Date(payment.updatedAt);
    return (
      <div className="flex-cols">
        <div className="text-jsm font-bold">
          {payment.payment_method !== "" ? payment.payment_method : "-"}
        </div>
        <div className="text-sm">
          {`${createdDate.toLocaleDateString()}, ${createdDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`}
        </div>
      </div>
    );
}

const IncomeStatementTable = ({handlePageChange}: IncomeStatementTableProps) => {
  const {bookingsPaging, bookings} = useSelector((state: RootState) => state.incomeStatement.state)
  
  const constructTableBody = (books: IncomeStatementBookingItem[]): TableBody => ({
    data: books.map((b) => ({
      id: b.id,
      value: {
        ...b,
        priceObject: {
          total: b.total_price,
          type: b.type
        },
        paymentObject: {
          payment_method: b.payment_method,
          updatedAt: b.updated_at
        }
      } as IncomeStatementBookingItemVO
    })),
    component: {
      custom_id: renderId,
      created_at: renderDate,
      customer: renderCustomer,
      type: renderType,
      paymentObject: renderPaymentMethod,
      priceObject: renderPrice
    },
  })


  return (
    <div className="j-col gap-6">
      <div className="text-jlg">Report Data</div>
      <Table
        headers={HEADERS}
        body={constructTableBody(bookings)}
        sort={SORT}
        meta={constructTableMetaFromPaging2(bookingsPaging)}
        pageNumberHandler={handlePageChange} />
    </div>
  )
  
}
export default IncomeStatementTable;
